var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "wave",
  "use": "wave-usage",
  "viewBox": "0 0 148 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"none\" viewBox=\"0 0 148 16\" id=\"wave\"><path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M74.023 0c26.85 0 45.84 15.54 72.783 15.99L148 16H0C26.716 16 46.78 0 74.023 0\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol